import { useLocation, useNavigate } from "react-router-dom";
import { tutorialsData } from "./tutorials-data";
import { Button } from "../../misc/Button";
import TutorialsComingSoon from "../../misc/HelpComingSoon";

const TutorialDetail: React.FC = () => {
    const navigate = useNavigate();

    const location = useLocation();

    const state = location.state;
    const tab = state?.tab;

    const path = window.location.pathname;
    const tutorial = tutorialsData.find((t) => t.link === path.split("/")[2]);

    if (!tutorial) {
        return (
            <div className="p-4 text-center text-red-500">
                Tutorial not found.
            </div>
        );
    }

    return (
        <div className="w-full px-4 py-12 bg-background">
            <Button
                onClick={() => {
                    if (tab && tab !== null && tab.length > 0) {
                        navigate("/help", { state: { tab } });
                    } else {
                        navigate("/help", { state: { tab: "tutorials" } });
                    }
                }}
                className="mb-4"
            >
                Back
            </Button>
            <h2 className="text-3xl font-bold mb-4 text-primary text-center">
                {tutorial.title}
            </h2>
            <p className="text-neutral-500 mb-6 text-center">
                {tutorial.description}
            </p>
            {tutorial.component ? (
                <tutorial.component />
            ) : (
                <TutorialsComingSoon />
            )}
        </div>
    );
};

export default TutorialDetail;
